import { render, staticRenderFns } from "./pcNew.vue?vue&type=template&id=f14fea1e&scoped=true&"
import script from "./pcNew.vue?vue&type=script&lang=js&"
export * from "./pcNew.vue?vue&type=script&lang=js&"
import style0 from "./pcNew.vue?vue&type=style&index=0&id=f14fea1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14fea1e",
  null
  
)

export default component.exports